import { useEffect, useCallback } from 'react';
import { useRouteFlow, FlowSource } from '../../flows/useRouteFlow';
import { addWindowListener } from '../../utils/eventListener';

type CallbackEvent = {
  callback: () => void;
};

const Listener = () => {
  const { handleOpen } = useRouteFlow(FlowSource.LINK);

  const handleEvent = useCallback(
    (event: CustomEvent<CallbackEvent>) => {
      handleOpen(event.detail.callback);
    },
    [handleOpen],
  );

  useEffect(() => {
    return addWindowListener('openFlows', handleEvent);
  }, [handleEvent]);

  return null;
};

export { Listener };
